export default __webpack_public_path__ + "static/media/screen1.b2c59434.jpg";